import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ApiService } from "../shared/services/api.service";
import { AuthService } from "../shared/services/auth.service";
import { map, switchMap, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class EmailTokenGuard implements CanActivate {
  constructor(private apiService: ApiService, private authService: AuthService) { }

  canActivate() {
  const token = window.location.href.split('token=')[1];
  if (token) {
    return this.apiService.loginWithToken(token).pipe(
      tap(response => {
        localStorage.setItem("access_token2", response.accessToken);
      }),
      switchMap(() => this.apiService.meInfo()),
      tap(userData => {
        this.authService.sendToken(
          userData.id_user,
          userData.n_user,
          userData.ape_user,
          userData.mail_user,
          userData.foto
        );
      }),
      map(() => true)
    );
  }

  return true;
}


}
